module.exports = __webpack_public_path__ + "static/img/2areaB_24.f35c67e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_24.png
// module id = 1149
// module chunks = 1